<template lang="html">

    <main class="ofertas-section">
        <nav class="ofertas-selector row-start">
            <button v-if="ofertas.empleo.length != 0" @click="selected = 'empleo'; numVerMas = 1;"
                :active="selected == 'empleo'">Ofertas Empleo</button>
            <button v-if="ofertas.practicas.length != 0" @click="selected = 'practicas'; numVerMas = 1;"
                :active="selected == 'practicas'">Ofertas Prácticas</button>
            <button v-if="programas.length != 0 && $route.fullPath == '/'"
                @click="selected = 'programas'; numVerMas = 1;" :active="selected == 'programas'">Programas
                activos</button>
        </nav>
        <div class="ofertas-list" v-if="selected == 'empleo' || selected == 'practicas'">
            <article class="oferta row-between ais"
                v-for="el in ofertas[selected].slice(0, (numBloqueOfertas * (numVerMas)))"
                v-if="ofertas[selected].length != 0" :proyecto-talento="el.paraProyectoTalento">
                <main>
                    <h5 class="empresa">{{ el.empresa }}</h5>
                    <h2>{{ el.titulo }}</h2>
                </main>
                <aside>
                    <h5 class="fecha">{{ el.fechaDestacada }}</h5>
                    <h5 class="provincia">{{ el.provincia }}</h5>
                </aside>
                <a target="_blank" :href="$t('portalalumno') + 'ofertas-' + selected + '/' + el.urlAcceso"
                    class="enlace-cover"></a>
            </article>
        </div>

        <div class="ofertas-list" v-if="selected == 'programas'">

            <article class="oferta -programa row-between ais"
                v-for="programa in programas.slice(0, (numBloqueOfertas * (numVerMas)))">
                <main>
                    <h5 class="empresa">{{ programa.financiacion }}</h5>
                    <h2>{{ programa.titulo }}</h2>
                    <p title="Nivel de estudios permitidos">
                        <template v-for="(estudio, pos) in programa.tiposEstudios">
                            {{ (pos == 1) ? 'y' : '' }} {{ tiposEstudios[estudio] }}
                        </template>
                    </p>
                </main>
                <aside>
                    <h5 class="fecha">{{ programa.fechaInicio }} {{ (!!programa.fechaFin) ? '-' : null }}
                        {{ programa.fechaFin }}</h5>
                    <h5 class="duracion" title="Duración">{{ programa | duracion }}</h5>

                </aside>
                <router-link :to="$t('enlaces.programasyofertas') + '/' + programa.urlAcceso" class="enlace-cover">
                </router-link>
            </article>
        </div>

        <!-- SI ESTOY EN LA HOME DEJO EL LINK QUE MANDA A /programas-y-ofertas -->
        <router-link class="link" v-if="selected == 'programas' && $route.fullPath == '/'"
            :to="$t('enlaces.programasyofertas')">Ver más</router-link>

        <!-- SI ESTOY EN /programas-y-ofertas ENTONCES PONGO EL BOTÓN DE "VER MÁS" QUE VA CARGANDO OFERTAR/PROGRAMAS DE 5 EN 5 -->
        <a @click="showMore" class="btn -solid-primary"
            v-if="(((selected == 'empleo' || selected == 'practicas') && ((numVerMas * numBloqueOfertas) < ofertas[selected].length)))">
            Ver más
        </a>
        <p v-if="linkExternoPortal && (selected == 'empleo' || selected == 'practicas')" class="link-externo">Hay más ofertas esperándote.<br> Regístrate o inicia sesión <a href="https://portal.uvaempleo.com/login"
                target="_blank" rel="noopener noreferrer">aquí</a> para ver las que mejor se adaptan a tu perfil.
        </p>
    </main>

</template>

<script lang="js">

import { mapGetters } from 'vuex';


export default {
    name: 'ofertas',
    data() {
        return {
            selected: 'programas',
            tiposEstudios: {
                1: "Estudios universitarios",
                2: 'Formación profesional'
            },
            numBloqueOfertas: 5,
            numVerMas: 1,
            linkExternoPortal: false
        }
    },
    computed: {
        ...mapGetters({
            ofertas: 'getOfertas',
            programas: 'getProgramas'
        }),

    },
    filters: {
        duracion(value) {


            let inicio = (!!value.meses) ? value.meses.split(",")[0] : '';
            let fin = (!!value.meses2) ? value.meses2.split(",")[0] : '';

            let string = inicio;
            string += (!!fin) ? ` ${value.operadorMeses} ${fin}` : '';
            string += (!!fin || inicio != "1") ? ' meses' : ' mes';

            return string;

        }
    },
    methods: {
        showMore() {
            this.numVerMas = this.numVerMas + 1,
            this.linkExternoPortal = true
        }
    },
    watch:{
        'selected'(){
            this.linkExternoPortal = false
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/components/view-parts/home/ofertas.vue